import { deserialize, deserializeAs, inheritSerialization } from 'cerialize';
import { Entity } from './entity';

@inheritSerialization(Entity)
export class Notification extends Entity {

  @deserialize
  subject: string;

  @deserialize
  resume: string;

  @deserialize
  content: string;

  @deserializeAs('created_at')
  createdAt: Date;

  @deserializeAs('readed_at')
  readedAt: Date;

  @deserializeAs('seen_at')
  seenAt: Date;

  @deserializeAs('redirect_to_for_front')
  redirectToForFront: string;

  @deserialize
  type: string;


  get read(): boolean {
    return this.readedAt != null;
  }
}
